<template>
  <div class="container flex flex-col h-full min-h-screen justify-between">
    <div>
      <StatusBar :level="level" :score="score" />

      <div>
        <transition name="component-fade" mode="out-in">
          <QuestionAB
            v-if="questionType && questionType == 'AB'"
            :showAnswer="showAnswer"
            :questionImageA="questionImageA"
            :questionImageB="questionImageB"
            :correct="correctAnswer"
            @answer="storeAnswer"
          />
          <QuestionScreen
            v-else
            :showAnswer="showAnswer"
            :questionImage="questionImage"
            :answerImage="answerImage"
            :correct="correctAnswer"
            @answer="storeAnswer"
          />
        </transition>
      </div>

      <div class="text-left md:max-w-lg mt-4">
        <ImageCredits />
      </div>
    </div>
    <ProgressBar
      :showAnswer="showAnswer"
      :progress="progress"
      @next-question="nextQuestion"
    />
  </div>
</template>

<script>
import StatusBar from "./StatusBar.vue";
import QuestionAB from "./QuestionAB.vue";
import QuestionScreen from "./QuestionScreen.vue";
import ProgressBar from "./ProgressBar.vue";
import ImageCredits from "./ImageCredits.vue";

export default {
  name: "QuizScreen",
  components: {
    StatusBar,
    QuestionAB,
    QuestionScreen,
    ProgressBar,
    ImageCredits,
  },
  props: {
    questionIndex: Number,
    progress: Number,
    questionType: String,
    questionImage: String,
    questionImageA: String,
    questionImageB: String,
    answerImage: String,
    correctAnswer: Boolean,
    score: Number,
    level: String,
    levelProgress: Number,
  },
  data() {
    return {
      showAnswer: false,
    };
  },
  methods: {
    nextStep() {
      this.$emit("next-step");
    },
    nextQuestion() {
      this.$emit("next-question");
      this.showAnswer = false;
    },
    storeAnswer(value) {
      console.log("answer: ", value);
      this.$emit("answer", this.questionIndex, value);
      this.showAnswer = true;
    },
  },
};
</script>

<style scoped lang="scss">
.question {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.3s ease;
}
.component-fade-enter,
.component-fade-leave-to {
  opacity: 0;
}
</style>
